import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { ApplyCouponValues } from "src/models/Student.model";
import { object, string } from "yup";
import ApplyCoupon from "./ApplyCoupon";
import { useGetCouponByCodeMutation } from "src/services/CouponServices";
import { showToast } from "src/utils/showToaster";

type Props = {
  onClose: () => void;
  setCouponData: any;
  studentId: string;
};

const ApplyCouponWrapper = ({ onClose, setCouponData, studentId }: Props) => {
  const [getCouponByCode] = useGetCouponByCodeMutation();
  // Form Initial Values
  const initialValues: ApplyCouponValues = {
    couponCode: "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    couponCode: string().required("Please enter coupon code"),
  });

  // Handle Submit
  const handleSubmit = (
    values: ApplyCouponValues,
    { setSubmitting, resetForm }: FormikHelpers<ApplyCouponValues>
  ) => {
    getCouponByCode({
      couponCode: values?.couponCode,
      studentId: studentId,
    }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
          setCouponData(res?.data?.data);
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <ApplyCoupon formikProps={formikProps} onClose={onClose} />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default ApplyCouponWrapper;
